import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
// @ts-ignore
import {ReactComponent as arrow_right_middle_bottom} from '../../assets/arrow_right_middle_bottom.svg';

const ArrowRightMiddleBottom: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      component={arrow_right_middle_bottom}
      viewBox='0 0 32 28'
    />
  );
};

export default ArrowRightMiddleBottom;
